export default __webpack_public_path__ + "static/media/axess_logo.5af14055.png";